<code class="numerals">{addDash($host.code)}</code>

<style>
code {
    font-size: 3em;
    letter-spacing: 0.1em;
}
</style>

<script>
import { host } from "../../../stores/host"

const addDash = code => code.substr(0,3) + '-' + code.substr(3,3)
</script>